import { useL10n } from "@ews/react-localization-context";
import SettingsTextInput from "../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import { TooltipIcon } from "../../../ToolTip/useTooltip";
import { useModifySystemSpecification, useSystemSpecification } from "../../../ReactData/system";

const InstallationCompany: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    const { translate: t } = useL10n();
    const specification = useSystemSpecification(systemId);
    const modifySystemSpecification = useModifySystemSpecification();

    return <>
        <SettingsTextInput
            text={"PLG_USER_PROFILE_LST_FIELD_SALUTATION_COMPANY"}
            tooltip={<TooltipIcon text={t("PLG_USER_PROFILE_LST_FIELD_SALUTATION_COMPANY")} />}
            inputType={"text"}
            value={specification.installationCompany?.company}
            onBlur={({ value }) =>
            {
                if (specification.installationCompany?.company === value) return;
                if (systemId && specification.installationCompany) {

                    const { address, telephoneNumber, email, contactPerson } = specification.installationCompany;
                    modifySystemSpecification(systemId, {
                        ...specification,
                        installationCompany: {
                            company: value,
                            address,
                            telephoneNumber,
                            email,
                            contactPerson
                        },
                    });
                }
            }
            } />
        <SettingsTextInput
            text={"TRVB_ADDRESS_LABEL"}
            tooltip={<TooltipIcon text={t("TRVB_ADDRESS_DESC")} />}
            inputType={"text"}
            value={specification.installationCompany?.address}
            onBlur={({ value }) =>
            {
                if (specification.installationCompany?.address === value) return;
                if (systemId && specification.installationCompany) {
                    const { company, telephoneNumber, email, contactPerson } = specification.installationCompany;
                    modifySystemSpecification(systemId, {
                        ...specification,
                        installationCompany: {
                            address: value,
                            company,
                            telephoneNumber,
                            email,
                            contactPerson
                        },
                    });
                }
            }
            } />
        <SettingsTextInput
            text={"TRVB_CLERK_LABEL"}
            tooltip={<TooltipIcon text={t("TRVB_CLERK_LABEL")} />}
            inputType={"text"}
            value={specification.installationCompany?.contactPerson}
            onBlur={({ value }) =>
            {
                if (specification.installationCompany?.contactPerson === value) return;
                if (systemId && specification.installationCompany) {
                    const { company, telephoneNumber, email } = specification.installationCompany;
                    modifySystemSpecification(systemId, {
                        ...specification,
                        installationCompany: {
                            contactPerson: value,
                            company,
                            telephoneNumber,
                            email
                        },
                    });
                }
            }
            } />
        <SettingsTextInput
            text={"TRVB_TEL_LABEL"}
            tooltip={<TooltipIcon text={t("TRVB_TEL_LABEL")} />}
            inputType={"tel"}
            value={specification.installationCompany?.telephoneNumber}
            onBlur={({ value }) =>
            {
                if (specification.installationCompany?.telephoneNumber === value) return;
                if (systemId && specification.installationCompany) {
                    const { address, email, company, contactPerson } = specification.installationCompany;
                    modifySystemSpecification(systemId, {
                        ...specification,
                        installationCompany: {
                            telephoneNumber: value,
                            address,
                            company,
                            email,
                            contactPerson
                        },
                    });
                }
            }
            } />

        <SettingsTextInput
            text={"TRVB_MAIL_LABEL"}
            tooltip={<TooltipIcon text={t("TRVB_MAIL_LABEL")} />}
            inputType={"email"}
            value={specification.installationCompany?.email}
            onBlur={({ value }) =>
            {
                if (specification.installationCompany?.email === value) return;
                if (systemId && specification.installationCompany) {
                    const { address, telephoneNumber, company, contactPerson } = specification.installationCompany;
                    modifySystemSpecification(systemId, {
                        ...specification,
                        installationCompany: {
                            email: value,
                            address,
                            telephoneNumber,
                            company,
                            contactPerson
                        },
                    });
                }
            }
            } />
    </>;
};

export default InstallationCompany;
